import { Typography } from '@mui/material';
import './Coming.css';
// import bigfont from '../images/bigfont.png';
import heroimg from '../images/heroimg.jpg';
import Grid from '@mui/material/Grid';

const Coming = () => {
    return (
        <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ padding: "0px 7rem", backgroundColor: "lavender" }}>
            <Grid item xs={12} sm={6}>
                <div className="text-container">
                    <Typography variant="h5" sx={{
                        padding: "10px", fontSize: "28px",
                        fontWeight: "600"
                    }}>" Instant Case Access for Gujarat Government</Typography>
                    <Typography variant="body1" sx={{ padding: "10px", textAlign: "justify" }}>
                        Easy Access to Complete Case Information for Government.
                    </Typography>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <img
                    src={heroimg}
                    alt="Your Image"
                    style={{ width: '100%', height: '100%', justifyItems: 'left', alignItems: 'left', display: 'flex', margin: '0 auto', marginTop: '100px', marginBottom: '80px' }}
                />
            </Grid>
        </Grid>




    )
}

export default Coming;
